import React from 'react';
import Head from 'next/head';

const defaultZapierImageUrl =
  'https://res.cloudinary.com/zapier-media/image/upload/f_auto/q_auto/v1657116755/Blog/Social/share_n8hila.jpg';

type Props = {
  title: string;
  description: string;
  image?: string;
  /**
   * https://developers.google.com/search/docs/guides/intro-structured-data
   */
  jsonLd?: { [key: string]: any };
  discoverable?: boolean;
};

export function Meta({
  title,
  description,
  image,
  jsonLd,
  // Discoverable by default. Opt out via 'false'
  discoverable = true,
}: Props) {
  const [url, setUrl] = React.useState('');

  React.useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <Head>
      <title>{title}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* "The bare minimum of <meta> tags necessary to make a web page amenable for sharing on social media": */}
      {/* https://css-tricks.com/essential-meta-tags-social-media/ */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultZapierImageUrl} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@zapier" />
      {!discoverable && <meta name="robots" content="noindex" />}
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </Head>
  );
}
